<template>
  <div class="wrap">
    <el-row class="header">
      <span :span="1" class="go-back el-icon-back" @click="goBack"></span>
      <el-col :span="23">
        <span class="name">
          {{row.strategyId}}
        </span >
        <span
         class="status"
         :style="{
           background:(row.batchStatus === 1 ? 'pink': row.batchStatus === 2 ? '#0070cc': row.batchStatus === 3 ? 'green' : row.batchStatus === 4 ? '#ff8a00' : '')
           }"
         >
         {{ row.batchStatus === 1 ? '待升级': row.batchStatus === 2 ? '升级中': row.batchStatus === 3 ? '已完成' : row.batchStatus === 4 ? '已取消' : '' }}
         </span>
      </el-col>
      <el-col :span="1">
        <el-button class="el-icon-refresh-right" @click="reflash"></el-button>
      </el-col>
    </el-row>
    <el-tabs v-model="activeName" @tab-click="handleClick" type="card">
      <el-tab-pane
      :label="item.title"
      :name="item.name"
      v-for="item in tabs"
      :key="item.name"
      >
        <!-- <keep-alive> -->
          <component
          v-if="item.name === activeName"
          :is='item.content'
          :key="timer"
          ></component>
        <!-- </keep-alive> -->
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import DeviceList from '@/components/firmwareUpdate/batchDetailTabs/batchDeviceList.vue'
import BatchInfos from '@/components/firmwareUpdate/batchDetailTabs/batchInfos.vue'
export default {
  data () {
    return {
      row: null,
      timer: '',
      activeName: '0',
      batchDetailTab: '0',
      tabs: [
        {
          title: '设备列表',
          name: '0',
          content: DeviceList
        },
        {
          title: '批次信息',
          name: '1',
          content: BatchInfos
        }
      ]
    }
  },
  created () {
    this.getActiveName()
    this.row = JSON.parse(this.$route.query.row)
    console.log(this.row)
  },
  methods: {
    reflash () {
      this.$nextTick(() => {
        this.timer = new Date().getTime()
      })
    },
    goBack () {
      window.history.go(-1)
    },
    getActiveName () {
      if (sessionStorage.getItem('batchDetailTab')) {
        this.activeName = sessionStorage.getItem('batchDetailTab')
      } else {
        this.activeName = '0'
      }
    },
    handleClick (tab) {
      if (tab.name === '0') {
        this.batchDetailTab = '0'
      }
      if (tab.name === '1') {
        this.batchDetailTab = '1'
      }
      sessionStorage.setItem('batchDetailTab', this.batchDetailTab)
    }
  }
}
</script>

<style lang='less' scoped>
  .wrap{
    padding: 0 24px 24px;
  }
  .header{
    display: flex;
    align-items: center;
    margin-bottom: 14px;
    .go-back{
      cursor: pointer;
    }
    .el-icon-back{
      font-size: 20px;
      font-weight: bold;
      width: 25px;
    }
    .el-col{
      display: flex;
      align-items: center;
      .el-col-22{
        display: flex;
        align-items: center;
      }
      .name{
        margin-left: 20px;
        font-size: 28px;
        font-weight: bold;
      }
      .status{
        font-weight: normal;
        font-size: 12px;
        padding: 2px 8px;
        border-radius: 15px;
        margin-left: 8px;
        display: inline-block;
        color: #f7f7f7;
      }
    }
    .el-button{
      border-radius: 0;
      font-weight: 900;
      font-size: 20px;
      padding: 8px 8px;
    }
  }
</style>
